import http from '../../lib/http'

const get = () => dispatch => {
  dispatch({ type: 'profile/loading' })
  return http
    .getRequest('/profile')
    .then(profile =>
      dispatch({
        type: 'profile/loaded',
        profile
      }))
    .catch(error =>
      dispatch({
        type: 'profile/error',
        error
      }))
}

const set = params => dispatch => {
  dispatch({ type: 'profile/loading' })
  return http
    .putRequest('/profile', params)
    .then(profile =>
      dispatch({
        type: 'profile/loaded',
        profile
      }))
    .catch(error =>
      dispatch({
        type: 'profile/error',
        error
      }))
}

export default {
  get,
  set
}
